import { motion } from "framer-motion";
import { CgCPlusPlus } from "react-icons/cg";
import { IoLogoElectron } from "react-icons/io5";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiPython,
  DiGit,
  DiDotnet,
} from "react-icons/di";
import { SiFirebase, SiNextdotjs, SiTypescript } from "react-icons/si";

function Techstack() {
  const technologies = [
    { icon: SiTypescript, name: "TypeScript" },
    { icon: DiJavascript1, name: "JavaScript" },
    { icon: DiNodejs, name: "Node.js" },
    { icon: DiReact, name: "React" },
    { icon: DiDotnet, name: ".NET" },
    { icon: SiNextdotjs, name: "Next.js" },
    { icon: DiGit, name: "Git" },
    { icon: SiFirebase, name: "Firebase" },
    { icon: CgCPlusPlus, name: "C++" },
    { icon: IoLogoElectron, name: "Electron" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 pb-12">
      {technologies.map((tech, index) => (
        <motion.div
          key={tech.name}
          initial={{ opacity: 0, scale: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3, delay: index * 0.05 }}
          viewport={{ once: true }}
          whileHover={{ scale: 1.1, rotate: 5 }}
          className="group relative flex items-center justify-center p-6 glass-effect rounded-lg border border-purple-900/30 hover:border-purple-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/30 overflow-visible"
        >
          <tech.icon className="text-5xl md:text-6xl text-purple-400 group-hover:text-purple-300 transition-colors duration-300" />

          {/* Tooltip */}
          <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 px-3 py-1 bg-dark-lighter rounded-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap z-50">
            {tech.name}
          </div>
        </motion.div>
      ))}
    </div>
  );
}

export default Techstack;
